import { useEffect, useRef, useState } from "react";
import { Bell, BookmarkCheck, BookmarkX, Loader, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthProvider";

export default function NotificationDropdown() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { notificationsLoading, handleMarkAsRead, handleDelete, notifications, updatingIds } = useAuth();

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const unreadCount = notifications.filter((n) => n.is_read === 0).length;

  return (
    <div className="relative" ref={dropdownRef}>
      <button onClick={() => setOpen(!open)} className="relative cursor-pointer w-6 h-6 flex justify-center item-center rounded-full transition hover:text-yellow-300 !mt-[3px]">
        <div>
          <Bell className="w-6 h-6" />
          {unreadCount > 0 && <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs flex items-center justify-center min-w-[18px] h-[18px] rounded-full font-medium">{unreadCount}</span>}
        </div>
      </button>

      {open && (
        <div className="absolute right-0 !mt-2 w-80 bg-white border !rounded-xl shadow-lg z-50">
          <div className="!p-3 border-b flex items-center justify-center">
            <h4 className="font-semibold text-center text-[#008080]">Notifications</h4>
            {notificationsLoading && <Loader2 className="w-4 h-4 animate-spin text-gray-600" />}
          </div>

          <div className="max-h-80 overflow-y-auto">
            {notifications.length === 0 ? (
              <p className="!p-4 text-gray-500 text-center text-sm">No notifications</p>
            ) : (
              notifications.map((n) => (
                <div key={n.id} className={`!p-3 border-b hover:!bg-gray-200 transition group ${!n.is_read ? "!bg-gray-100" : "!bg-white"}`}>
                  <div className="flex justify-between item-center">
                    <p className="text-sm text-left text-[#008080]">{n.title}</p>
                    <div>
                      {updatingIds.has(n.id) ? (
                        <Loader className="w-4 h-4 animate-spin text-gray-500" />
                      ) : (
                        <div className="flex justify-center item-center !space-x-1">
                          {!n.is_read && <BookmarkCheck className="text-green-400 w-4 h-4 cursor-pointer hover:text-green-700" onClick={() => handleMarkAsRead(n.id)} />}
                          <BookmarkX className="text-red-400 w-4 h-4 cursor-pointer hover:text-red-700" onClick={() => handleDelete(n.id)} />
                        </div>
                      )}
                    </div>
                  </div>
                  <p className="text-xs text-gray-500 text-left line-clamp-3">{n.message}</p>
                  <div className="flex item-end justify-end">
                    <p className={`text-black text-xs text-right text-gray-500 group-hover:!bg-gray-200 !px-2 !-mt-4 rounded-lg  ${!n.is_read ? "!bg-gray-100" : "!bg-white"}`}>{new Date(n.created_at).toLocaleString()}</p>
                  </div>
                </div>
              ))
            )}
          </div>

          <button onClick={() => (window.location.href = "/notifications")} className="w-full text-center !p-3 text-[#008080] hover:!bg-gray-100 border-t border-[#008080] font-medium cursor-pointer rounded-b-lg">
            View all notifications
          </button>
        </div>
      )}
    </div>
  );
}
